import { useState } from 'react';
import { LANGUAGES, SETTINGS } from '../constants';

export const useVisualizationState = () => {
  const [selectedModel, setSelectedModel] = useState('');
  const [viewType, setViewType] = useState('lines');
  const [selectedMethod, setSelectedMethod] = useState('');
  const [selectedLanguages, setSelectedLanguages] = useState(LANGUAGES);
  const [selectedSettings, setSelectedSettings] = useState(SETTINGS);
  const [heatmapMetric, setHeatmapMetric] = useState('absolute');
  const [statisticalView, setStatisticalView] = useState('mean');

  return {
    selectedModel,
    setSelectedModel,
    viewType,
    setViewType,
    selectedMethod,
    setSelectedMethod,
    selectedLanguages,
    setSelectedLanguages,
    selectedSettings,
    setSelectedSettings,
    heatmapMetric,
    setHeatmapMetric,
    statisticalView,
    setStatisticalView
  };
};